export function getSelectedId() {
  return this.state.selectedService &&
    this.state.selectedService.id ||
    this.props.assignedExpertServiceId;
}
